import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertBasic from "../alerts/AlertBasic";

class SubtestTypes extends Component {
    state = { subtestTypeList: [] };

    getSubtestTypes = async () => {
        const { fetchURL, defaultValue } = this.props;
        try {
            const response = await fetch(`${fetchURL}/subtest-types`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === true) {
                        const subtestTypeList = fetchedData.subtestTypes;
                        if (defaultValue === "all") {
                            subtestTypeList.unshift({
                                key: 0,
                                value: "all",
                                text: "Wszystkie",
                            });
                        }
                        if (this.props.bothTests) {
                            subtestTypeList.push({
                                key: subtestTypeList.length + 1,
                                value: "PJM+PL",
                                text: "PJM + PL",
                            });
                        }
                        this.setState({ subtestTypeList: subtestTypeList });
                    } else if (fetchedData.status === false) {
                        this.setState({ alert: { variant: "danger", message: fetchedData.message } });
                    }
                });
            } else {
                this.setState({ alert: { variant: "danger", message: response.status } });
            }
        } catch (err) {
            this.setState({ loading: false, alert: { variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." } });
            setTimeout(this.getSubtestTypes(), 4000);
        }
    };

    componentDidMount() {
        this.getSubtestTypes();
    }

    render() {
        const { subtestTypeList, alert } = this.state;
        const { defaultValue, onSubtestTypeSelected, req, testForm, id } = this.props;

        return (
            <Fragment>
                {alert && <AlertBasic variant={alert.variant} mssg={alert.message} onCloseAlert={() => this.setState({ alert: "" })} fading={alert.fading} />}

                <Form.Group>
                    <Form.Label>
                        {testForm ? "Wariant testu" : "Część testu"} {req && <span className="required">*</span>}
                    </Form.Label>

                    <Dropdown
                        value={defaultValue}
                        id={id ? id : "questionSubtestTypesDropdown"}
                        className={req ? "form-dropdown mb-3 req" : "form-dropdown mb-3"}
                        placeholder="Wszystkie"
                        fluid
                        selection
                        options={subtestTypeList}
                        onChange={(event, { value }) => {
                            onSubtestTypeSelected(event, value);
                        }}
                    />
                </Form.Group>
            </Fragment>
        );
    }
}

export default SubtestTypes;
